import CircularProgress from "@mui/material/CircularProgress";
import {useHistory} from 'react-router-dom'
import { useEffect } from "react";
import BaseUrl from "../BaseUrl";
import axios from "axios";
export default function TeamLoad(props){
    const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
    const id = props.match.params[0];
    const history = useHistory();
    useEffect(() => {
    
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${BaseUrl.baseurl}/email-marketing/user/accept-invitation/${userDetails && userDetails.details._id}/${id}`,
            headers: { 
              'Authorization': `Bearear ${userDetails&&userDetails.token}`
            }
          };
          
          axios.request(config)
          .then((response) => {
            if (response.data.status) {
                history.push('/Accounts/team')
            } else {
              if (response.data.tokenExpire) {
                localStorage.removeItem("MailSenderuserDetails");
                window.location.reload();
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
    }, []);
    return(
        <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress
        size={60}
        style={{
          color: "#1C485F",
        }}
      />
    </div>
    )
}